import { TypeInfoIcon } from "./TypeInfoIcon";
import { TypeInfoRoot } from "./TypeInfoRoot";
import { TypeInfoText } from "./TypeInfoText";

export const TypeInfo = {
  Root: TypeInfoRoot,
  Icon: TypeInfoIcon,
  Text: TypeInfoText,
};
